var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconOutlineTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#F60"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.222 19.694h-2.815v-2.775c0-.767-.63-1.387-1.407-1.387s-1.407.62-1.407 1.387v4.162c0 .767.63 1.387 1.407 1.387h4.222c.777 0 1.408-.62 1.408-1.387s-.63-1.387-1.408-1.387M19 30.445c-5.238 0-9.5-4.2-9.5-9.364 0-5.164 4.262-9.364 9.5-9.364s9.5 4.2 9.5 9.364c0 5.163-4.262 9.364-9.5 9.364m1.39-21.77c.003-.028.017-.05.017-.08V7.208h1.408c.777 0 1.407-.62 1.407-1.387 0-.768-.63-1.388-1.407-1.388h-5.63c-.777 0-1.407.62-1.407 1.388 0 .767.63 1.387 1.407 1.387h1.408v1.387c0 .03.014.052.016.08-6.331.686-11.276 5.986-11.276 12.406 0 6.885 5.683 12.486 12.667 12.486s12.667-5.6 12.667-12.486c0-6.42-4.945-11.72-11.276-12.405",
    transform: "translate(-752 -283) translate(752 283)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOutlineTimer);
export default __webpack_public_path__ + "static/media/icon-outline-timer.297297cc67b7111282e8563fe53e3c46.svg";
export { ForwardRef as ReactComponent };